import { observer } from 'mobx-react';
import Modal from '../../../../../Modal';
import { ExperienceResource } from '../Types';
import { T } from '../../../../../../Translations';
import { CheckBox } from '@execonline-inc/execonline-ui';
import { L } from '@execonline-inc/translations';

export interface Props {
  close: () => void;
  isOpen: boolean;
  experienceResource: ExperienceResource;
  selectedDateIds: Set<number>;
  onSelectionChange: (id: number, selected: boolean) => void;
}

function EditStartDatesModal({
  isOpen,
  close,
  experienceResource,
  selectedDateIds,
  onSelectionChange,
}: Props) {
  if (!isOpen) {
    return <></>;
  }

  const scheduledDates = experienceResource.payload.program_instance_options.scheduled;

  const handleCheckboxChange = (id: number, checked: boolean) => {
    onSelectionChange(id, checked);
  };

  return (
    <Modal
      close={close}
      title={<></>}
      modalWidth="w-[480px]"
      customBackgroundCssClasses="bg-primary/10 opacity-60"
      data-intercom-target="builder-v2-edit-dates-modal"
    >
      <div className="flex flex-col px-4">
        <div className="text-xl font-semibold">
          <T kind="Update Start Dates" />
        </div>
        <div className="mt-4 text-sm">
          <T kind="Select one or more dates for participants to choose from when enrolling." />
        </div>
        <div className="text-sm text-muted-foreground">
          <T kind="(Note: participants may only enroll in one-date per program)" />
        </div>
        <div className="mt-6 font-semibold">
          <T kind="Program" />
        </div>
        <div className="mt-2">{experienceResource.payload.title}</div>
        <div className="mt-6 font-semibold">
          <T kind="Select Start Date(s)" />
        </div>
        <div className="mt-2 flex flex-col gap-3 pb-4">
          {scheduledDates.map((scheduledOption) => (
            <label key={scheduledOption.id} className="flex items-center gap-2 cursor-pointer">
              <CheckBox
                checked={selectedDateIds.has(scheduledOption.id)}
                onChange={(e) => handleCheckboxChange(scheduledOption.id, e.target.checked)}
                data-intercom-target="builder-v2-edit-dates-checkbox"
              />
              <L localizeable={scheduledOption.start_on} format="long-weekday-month-year" />
            </label>
          ))}
        </div>
      </div>
    </Modal>
  );
}

export default observer(EditStartDatesModal);
